import { render, staticRenderFns } from "./ProjectAccessApproval.vue?vue&type=template&id=20138514"
import script from "./ProjectAccessApproval.vue?vue&type=script&lang=ts"
export * from "./ProjectAccessApproval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-bcca2229bc/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/.yarn/cache/vue-hot-reload-api-npm-2.3.4-549ae26337-9befc0b3d6.zip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20138514')) {
      api.createRecord('20138514', component.options)
    } else {
      api.reload('20138514', component.options)
    }
    module.hot.accept("./ProjectAccessApproval.vue?vue&type=template&id=20138514", function () {
      api.rerender('20138514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProjectAccessApproval.vue"
export default component.exports